import { React, useEffect, useState } from "react";
import Diamond from "../../../images/Diamond.png"
import sharewithfriendicon from "../../../images/sharewithfriendicon.png";
import kills from "../../../images/kills.png";
import userimg from "../../../images/user.png";
import ranksimg from "../../../images/ranks.png";
import Coin from "../../../images/coin.png"
import { scrimById, scrimUserDetails } from "../../../api/scrim.api";
import { findValueByName, formatDate, formatTime, shareLink } from "../../../Utilities/helper";
import { toastInfo } from "../../../Utilities/toast";
import { t } from "i18next";
import ListLoader from '../../Common/ListLoader';
import { RWebShare } from "react-web-share";
import premiumicon from "../../../images/premium.png";
const PrivateContestBox = ({ scrimId }) => {
  const [percentage, setPercentage] = useState(0);
  const [scrim, setScrim] = useState(null)
  const [captain, setCaptain] = useState(null)
  const [loading,setLoading] = useState(false)

  useEffect(() => {
    fetchScrimById();
  }, [scrimId])

  const fetchScrimById = async () => {
    setLoading(true)
    try {
      var response = await scrimById({ id: scrimId });
      setLoading(false)
      if (response?.success && response?.data) {
        setScrim(response?.data)
        setPercentage((response?.data?.noOfJoinedPlayer / response?.data?.noOfPlayerCapacity) * 100);
      }
      fetchCaptainInfo();
    } catch (error) { 
      setLoading(false)
    }
  };
  const fetchCaptainInfo = async () => {
    try {
      var response = await scrimUserDetails({ scrimId: scrimId, userId: JSON.parse(localStorage.getItem("profile"))?.user_id });
      if (response?.success && response?.data) {
        setCaptain(response?.data)
      }
    } catch (error) { }
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(scrim?.shortCode).then(() => {
      toastInfo("short code copied");
    }).catch(err => {
    });
  };
  return (
    <>
    
    {scrim ?
    

(  <div className="tournamentround-detail-container">
  <div className="container tournament-card--wrap mt-4">
    <div className="tournament-card mb-4">
      <div className="card-body d-flex flex-column justify-content-between">
        <div className="d-flex justify-content-between align-items-center">
          <div className="card-title">   {scrim?.title?.length > 25 ? (
                      <marquee> {scrim?.title}</marquee>
                    ) : (
                      scrim?.title
                    )}</div>
          <button className="btn rules-btn" style={{ width: "fit-content" }} onClick={handleCopy}>ID-{scrim?.shortCode}</button>
        </div>

        <hr style={{margin:"0.5rem 0"}}></hr>
        <div className="row">
          <div className="col-12">
            <div className="tournament-card-detail">
              <div className="row">
                {/* First row (date, round, ID) */}
                <div className="col-12 tournament-card-box--wrap">
                  <div className="row">
                    <div className="col-3 tournament-card-box">
                      <div className="detail-item">
                        <div className="tournament-detail-label letter-spacing">
                        {/* {scrim?.date.length > 7 ? (
                                    <marquee>{formatDate(scrim?.date)}</marquee>
                                  ) : (
                                    formatDate(scrim?.date)
                                  )} */}
                                  {formatDate(scrim?.date)}
                        </div>
                        <div className="tournament-detail-value">
                          date
                        </div>
                      </div>
                    </div>
                    <div className="col-3 tournament-card-box">
                      <div className="detail-item">
                        <div className="tournament-detail-label">
                          {formatTime(scrim?.date)}
                        </div>
                        <div className="tournament-detail-value">
                          time
                        </div>
                      </div>
                    </div>
                    {scrim?.titles?.[0]?.isSelection && scrim?.titles?.[0]?.name && scrim?.titles?.[0]?.value &&
                      <div className="col-3 tournament-card-box">
                        <div className="detail-item">
                          <div className="tournament-detail-label">
                          {/* {scrim?.titles?.[0]?.value.length > 5 ? (
                                        <marquee>
                                          {scrim?.titles?.[0]?.value}
                                        </marquee>
                                      ) : (
                                        scrim?.titles?.[0]?.value
                                      )} */}
                                       {scrim?.titles?.[0]?.value}
                          </div>
                          <div className="tournament-detail-value">
                          {/* {scrim?.titles?.[0]?.name.length > 8 ? (
                                        <marquee>
                                          {scrim?.titles?.[0]?.name}
                                        </marquee>
                                      ) : (
                                        scrim?.titles?.[0]?.name
                                      )} */}
                                        {scrim?.titles?.[0]?.name}
                          </div>
                        </div>
                      </div>
                    }
                    {scrim?.titles?.[1]?.isSelection && scrim?.titles?.[1]?.name && scrim?.titles?.[1]?.value &&
                      <div className="col-3 tournament-card-box">
                        <div className="detail-item">
                          <div className="tournament-detail-label">
                          {/* {scrim?.titles?.[1]?.value.length > 5 ? (
                                        <marquee>
                                          {scrim?.titles?.[1]?.value}
                                        </marquee>
                                      ) : (
                                        scrim?.titles?.[1]?.value
                                      )} */}
                                        {scrim?.titles?.[1]?.value}
                          </div>
                          <div className="tournament-detail-value">
                          {/* {scrim?.titles?.[1]?.name.length > 8 ? (
                                        <marquee>
                                          {scrim?.titles?.[1]?.name}
                                        </marquee>
                                      ) : (
                                        scrim?.titles?.[1]?.name
                                      )} */}
                                      {scrim?.titles?.[1]?.name}
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-2">
          <div className="tournament-details-winnings tournament-details-winnings-1">
            <div className="d-flex" style={{ gap: "30px" }}>
              <p className="prize-info">
                players
                <span className="tournament-prizepool">{scrim?.noOfPlayerCapacity}

                </span>
              </p>
              <p className="prize-info">
                winners
                <span className="tournament-prizepool">{scrim?.noOfWinner}

                </span>
              </p>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-between align-items-center mt-2">
          {/* Progress Bar */}
          <div
            className="progress"
            style={{ height: "6px", width: "100%" }}
          >
            <div
              className="progress-bar"
              role="progressbar"
              style={{
                width: `${percentage}%`,
                backgroundColor: "#9F6693",
              }}
              aria-valuenow={scrim?.noOfJoinedPlayer}
              aria-valuemin="0"
              aria-valuemax={scrim?.noOfPlayerCapacity}
            ></div>
          </div>
        </div>

        <p className="progressbar-text mt-2 mb-0">
          <div>{scrim?.noOfJoinedPlayer} {scrim?.noOfJoinedPlayer > 1 ? 'players' : 'player'} joined</div>
          <div>{scrim?.noOfPlayerCapacity}</div>
        </p>
        <div className="d-flex justify-content-between align-items-center tournament-copied-detail--wrap mt-1">
          <div className="tournament-copied-detaild d-block">
          {scrim?.room?.id != null ? (<>
              <span className="tournament-details-roomid-value">
                {" "}
                {scrim?.room?.id == null ? '-' : scrim?.room?.id}{" "}
              </span> {" "}

              <span className="tournament-detail-svg" onClick={() => {
                navigator.clipboard.writeText(scrim?.room?.id);
                toastInfo(t("my_tournament.room_id_copied"))
              }} style={{ cursor: 'pointer' }}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="9"
                  height="10"
                  viewBox="0 0 9 10"
                  fill="none"
                >
                  <g clip-path="url(#clip0_2738_2557)">
                    <path
                      d="M8.8965 1.965L7.0515 0.1C6.9885 0.035 6.8985 0 6.8085 0H3.114C2.412 0 1.845 0.575 1.845 1.28V1.86H1.269C0.567 1.86 0 2.435 0 3.14V8.72C0 9.425 0.5715 10 1.269 10H5.886C6.588 10 7.155 9.425 7.155 8.72V8.14H7.731C8.433 8.14 9 7.565 9 6.86V2.21C9 2.12 8.964 2.03 8.8965 1.965ZM7.155 1.19L7.821 1.86H7.155V1.19ZM6.462 8.72C6.462 9.04 6.2055 9.3 5.886 9.3H1.269C0.9495 9.3 0.693 9.04 0.693 8.72V3.14C0.693 2.82 0.9495 2.56 1.269 2.56H1.845V6.86C1.845 7.565 2.4165 8.14 3.114 8.14H6.462V8.72ZM7.731 7.44H3.114C2.7945 7.44 2.538 7.18 2.538 6.86V1.28C2.538 0.96 2.7945 0.7 3.114 0.7H6.462V2.21C6.462 2.405 6.615 2.56 6.8085 2.56H8.307V6.86C8.307 7.18 8.0505 7.44 7.731 7.44Z"
                      fill="white"
                    />
                    <path
                      d="M6.80834 5.57996H4.04084C3.85184 5.57996 3.69434 5.73496 3.69434 5.92996C3.69434 6.12496 3.84734 6.27996 4.04084 6.27996H6.80834C6.99734 6.27996 7.15484 6.12496 7.15484 5.92996C7.15484 5.73496 7.00184 5.57996 6.80834 5.57996Z"
                      fill="white"
                    />
                    <path
                      d="M6.80834 3.71997H4.04084C3.85184 3.71997 3.69434 3.87497 3.69434 4.06997C3.69434 4.26497 3.84734 4.41997 4.04084 4.41997H6.80834C6.99734 4.41997 7.15484 4.26497 7.15484 4.06997C7.15484 3.87497 7.00184 3.71997 6.80834 3.71997Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_2738_2557">
                      <rect width="9" height="10" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </span></>) : <>-</>
            }
            <div className="tournament-details-roomid-lable">
              room id
            </div>{" "}
          
          </div>
          <div className="tournament-copied-detaild d-block">
            <div className="d-flex justify-content-end align-items-center">
            {scrim?.room?.password != null ? (<>
              <span className="tournament-details-roomid-value">
                {" "}
                {scrim?.room?.password ?? '-'}{" "}
              </span> {" "}

              <span className="tournament-detail-svg ms-1" onClick={() => {
                navigator.clipboard.writeText(scrim?.room?.password);
                toastInfo(t("my_tournament.room_password_copied"))
              }} style={{ cursor: 'pointer' }}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="9"
                  height="10"
                  viewBox="0 0 9 10"
                  fill="none"
                >
                  <g clipPath="url(#clip0_2738_2557)">
                    <path
                      d="M8.8965 1.965L7.0515 0.1C6.9885 0.035 6.8985 0 6.8085 0H3.114C2.412 0 1.845 0.575 1.845 1.28V1.86H1.269C0.567 1.86 0 2.435 0 3.14V8.72C0 9.425 0.5715 10 1.269 10H5.886C6.588 10 7.155 9.425 7.155 8.72V8.14H7.731C8.433 8.14 9 7.565 9 6.86V2.21C9 2.12 8.964 2.03 8.8965 1.965ZM7.155 1.19L7.821 1.86H7.155V1.19ZM6.462 8.72C6.462 9.04 6.2055 9.3 5.886 9.3H1.269C0.9495 9.3 0.693 9.04 0.693 8.72V3.14C0.693 2.82 0.9495 2.56 1.269 2.56H1.845V6.86C1.845 7.565 2.4165 8.14 3.114 8.14H6.462V8.72ZM7.731 7.44H3.114C2.7945 7.44 2.538 7.18 2.538 6.86V1.28C2.538 0.96 2.7945 0.7 3.114 0.7H6.462V2.21C6.462 2.405 6.615 2.56 6.8085 2.56H8.307V6.86C8.307 7.18 8.0505 7.44 7.731 7.44Z"
                      fill="white"
                    />
                    <path
                      d="M6.80834 5.57996H4.04084C3.85184 5.57996 3.69434 5.73496 3.69434 5.92996C3.69434 6.12496 3.84734 6.27996 4.04084 6.27996H6.80834C6.99734 6.27996 7.15484 6.12496 7.15484 5.92996C7.15484 5.73496 7.00184 5.57996 6.80834 5.57996Z"
                      fill="white"
                    />
                    <path
                      d="M6.80834 3.71997H4.04084C3.85184 3.71997 3.69434 3.87497 3.69434 4.06997C3.69434 4.26497 3.84734 4.41997 4.04084 4.41997H6.80834C6.99734 4.41997 7.15484 4.26497 7.15484 4.06997C7.15484 3.87497 7.00184 3.71997 6.80834 3.71997Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_2738_2557">
                      <rect width="9" height="10" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </span> </>) : <>-</>
            }
            </div>
            <div className="tournament-details-roomid-lable">
              password
            </div>{" "}
       
          </div>
        </div>
      </div>
    </div>
  </div>
</div>):(  !loading &&<>

        <div className="w-100 d-flex justify-content-center">
          <div className="no-record-found-center">{t("common.no_data_found")}</div>
        </div>
</>)}

{loading && <div className='w-100 d-flex justify-content-center'> <ListLoader /></div>}
      {captain != null ? (
        <div className="tournament-detail-playertable pt-4">
          <div className="player-header">
            <div className="player-header-item">
              <img className="players-table-img" src={userimg}></img>
              {t("private_contest.user_name")}
            </div>
            <div className="player-header-item">

            </div>

            <div className="player-header-item">
              <img className="players-table-img" src={ranksimg}></img> {t("private_contest.rank")}
            </div>

          </div>
          <div className="player-row">
            <div className="player-row-item" style={{ textAlign: "center" }}>
               {/* {
              captain.gamerjiName &&
              captain.gamerjiName.length > 15 ? (
                <marquee>{captain.gamerjiName}</marquee>
              ) : (
                captain?.gamerjiName
              )} */}
              {captain?.gamerJiName}
              {captain?.isPremium &&
                            <img
                              className="players-table-img"
                              src={premiumicon}
                              alt="Premium Icon"
                            />
                     }
              </div>
            <div className="player-row-item"></div>

            <div className="player-row-item">{captain?.rank ?? '-'}</div>

          </div>
        </div>
      ) : <></>
      }

        <RWebShare
          data={shareLink(scrim?.shortCode)}
          sites={["facebook", "twitter", "whatsapp", "linkedin", "copy"]}
          onClick={() => { console.log("shared successfully!") }}>
        <button className="d-flex justify-content-center submit-button mt-4 mb-4">
          <span><img className="sharewithfriendscontesttournament-img" src={sharewithfriendicon} alt=""></img></span>
          <div className="sharewithfriendscontesttournament-text">{t("private_contest.share_with_friends")}</div>
        </button>
      </RWebShare>

    </>
  );
};

export default PrivateContestBox;